import { Flex, Box } from 'components/ui';
import { Row, Col } from 'react-grid-system';
import RoundedBox from 'components/Traits/RoundedBox';
import TraitsGallery from 'components/TraitsGallery';
import futuraIcon from 'img/futura-icon.svg';
import master1  from 'img/master-1.png';
import master2 from 'img/master-2.png';
import master3 from 'img/master-3.png';
import master4 from 'img/master-4.png';
import master5 from 'img/master-5.png';
import master6 from 'img/master-6.png';
import master7 from 'img/master-7.png';
import master8 from 'img/master-8.png';
import master9 from 'img/master-9.png';
import master10 from 'img/master-10.png';
import master11 from 'img/master-11.png';

interface FuturaMasterProps {}

const FuturaMaster: React.FC<FuturaMasterProps> = () => {
  return (
    <Row>
      <Col xs={12} sm={12} md={5}>
        <RoundedBox>
          <TraitsGallery
            items={[
              {
                title: 'Master #1',
                content: (
                  <Box>
                    <img src={master1} width="100%" alt="master 1" />
                  </Box>
                ),
              },
              {
                title: 'Master #2',
                content: (
                  <Box>
                    <img src={master2} width="100%" alt="master 2" />
                  </Box>
                ),
              },
              {
                title: 'Master #3',
                content: (
                  <Box>
                    <img src={master3} width="100%" alt="master 3" />
                  </Box>
                ),
              },
              {
                title: 'Master #4',
                content: (
                  <Box>
                    <img src={master4} width="100%" alt="master 4" />
                  </Box>
                ),
              },
              {
                title: 'Master #5',
                content: (
                  <Box>
                    <img src={master5} width="100%" alt="master 5" />
                  </Box>
                ),
              },
              {
                title: 'Master #6',
                content: (
                  <Box>
                    <img src={master6} width="100%" alt="master 6" />
                  </Box>
                ),
              },
              {
                title: 'Master #7',
                content: (
                  <Box>
                    <img src={master7} width="100%" alt="master 7" />
                  </Box>
                ),
              },
              {
                title: 'Master #8',
                content: (
                  <Box>
                    <img src={master8} width="100%" alt="master 8" />
                  </Box>
                ),
              },
              {
                title: 'Master #9',
                content: (
                  <Box>
                    <img src={master9} width="100%" alt="master 9" />
                  </Box>
                ),
              },
              {
                title: 'Master #10',
                content: (
                  <Box>
                    <img src={master10} width="100%" alt="master 10" />
                  </Box>
                ),
              },
              {
                title: 'Master #11',
                content: (
                  <Box>
                    <img src={master11} width="100%" alt="1 twist" />
                  </Box>
                ),
              },
            ]}
          />
        </RoundedBox>
      </Col>

      <Col xs={12} sm={12} md={7}>
        <RoundedBox maxHeight="565px" overflowY="scroll">
          <Flex mb={3} alignCenter>
            <img src={futuraIcon} width="24px" alt="infinity" style={{ opacity: 0.5 }} />
            <Box ml={3} fontWeight="bold" fontSize={3}>
              FuturaMaster
            </Box>
          </Flex>
          <Box mt={3}>
            The eleven Futura Master NFTs were the first Futura Mixes to be minted and are tokens #1
            to #11 in the supply. They are similar to Futura Mix NFTs in that they draw from the
            same pool of underlying musical clips, layers and sections used to generate each Futura
            Mix. Each Futura Master has, however, been hand-crafted by the EulerBeats team. Each
            Futura Master is a human-created song, specifically chosen to represent various key
            creative aspects of the Futura drop.
          </Box>
          <Box mt={3}>
            Each Futura Master has the following unique qualities:
            <ul>
              <li>
                They are not able to be minted as part of the Futura Mix or Remix minting process.
                And like all other Futura Mix NFTs and Remix NFTs, each Futura Master is unique and
                cannot be duplicated by subsequent mints.{' '}
              </li>
              <li>
                Unlike a Futura Mix or Remix, a Futura Master can never be burned (eg to apply
                discounts during Remixing)
              </li>
              <li>
                Futura Masters each contain their own distinct traits that are not present in any
                Futura Mix. Thus, Futura Master holders can create Futura Remix NFTs that nobody
                else will ever be able to, unless those traits are used in new Remixes and
                distributed.
              </li>
              <li>
                Each Futura Master NFT is assigned the trait ‘Generation 0’. These are the only
                Futura NFTs to possess this trait value - A Futura Mix is Generation 1, and Remixes
                have a minimum Generation of 2.
              </li>
              <li>
                The eleven Master NFTs are the OG tokens in the supply and feature Futura Token IDs
                1-11.
              </li>
            </ul>
          </Box>
        </RoundedBox>
      </Col>
    </Row>
  );
};

export default FuturaMaster;
